import $ from 'jquery';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import ContentSyncSliderAnimation from './content-sync-slider-animation';
const defaultSelectors = {
    content: '.js__content-sync-slider-content',
    nextButton: '.js__content-sync-slider-next',
    pagination: '.js__content-sync-slider-pagination',
    previousButton: '.js__content-sync-slider-previous',
    slider: '.js__content-sync-slider-swiper',
};
export default class ContentSyncSlider {
    static selector = '.js__content-sync-slider';
    static create($root, selectors = defaultSelectors, $animationRoot = $root, onSlideActivate) {
        const sliderElement = $root.find(selectors.slider).get(0);
        const pagination = $root.find(selectors.pagination).get(0);
        const previousButton = $root.find(selectors.previousButton).get(0);
        const nextButton = $root.find(selectors.nextButton).get(0);
        if (!sliderElement || !pagination || !previousButton || !nextButton) {
            return null;
        }
        const animation = ContentSyncSliderAnimation.init($animationRoot);
        const activateSlide = (activeIndex) => {
            $root.find(selectors.content).each((index, content) => {
                const isActive = index === activeIndex;
                const $content = $(content);
                $content.toggleClass('d-flex opacity-100 visible', isActive);
                $content.toggleClass('d-none opacity-0 invisible', !isActive);
                $content.attr('aria-hidden', String(!isActive));
            });
            animation?.activate(activeIndex);
            onSlideActivate?.(activeIndex, $root);
        };
        const slider = new Swiper(sliderElement, {
            modules: [Navigation, Pagination],
            speed: 400,
            loop: false,
            watchOverflow: true,
            navigation: {
                addIcons: false,
                prevEl: previousButton,
                nextEl: nextButton,
            },
            pagination: {
                el: pagination,
                clickable: false,
                bulletClass: 'slider-pagination-bar rounded-pill bg-gray',
                bulletActiveClass: 'bg-accent',
            },
            on: {
                slideChange: (activeSlider) => activateSlide(activeSlider.activeIndex),
            },
        });
        return {
            activate: () => {
                slider.update();
                activateSlide(slider.activeIndex);
            },
            deactivate: () => animation?.deactivate(),
        };
    }
    static init(onSlideActivate) {
        $(this.selector).each((_index, root) => {
            const $root = $(root);
            this.create($root, defaultSelectors, $root, onSlideActivate)?.activate();
        });
    }
}
